import { useIsAuthenticated } from "@azure/msal-react";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../routes/constants";

const theme = createTheme({
  typography: {
    fontFamily: "GeneralSans-Variable",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'GeneralSans-Variable';
          font-style: normal;
          font-weight: 400;
          letter-spacing: 0.01em;
        }
      `,
    },
  },
});

const AuthLayout = ({ children }: any) => {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(ROUTES.LOGIN);
    }
  }, [isAuthenticated, navigate]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
};

export default AuthLayout;
